import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

function migrateLegacyHashRoute(): void {
  const legacyRoute = window.location.hash;
  if (!legacyRoute.startsWith("#/")) return;

  window.history.replaceState(window.history.state, "", legacyRoute.slice(1));
}

migrateLegacyHashRoute();

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error(err);
  showBootstrapFailure();
});

function showBootstrapFailure(): void {
  const preboot = document.querySelector<HTMLElement>(".app-preboot");
  if (!preboot) return;

  const copy = {
    ar: {
      title: "تعذّر تحميل Dashy",
      message:
        "تحقق من اتصالك بالإنترنت، ثم أعد تحميل الصفحة. إذا استمرت المشكلة، جرّب مرة أخرى بعد بضع دقائق أو تواصل مع مسؤول النظام.",
      retry: "إعادة المحاولة",
    },
    en: {
      title: "Unable to load Dashy",
      message:
        "Check your internet connection and reload the page. If the problem continues, try again in a few minutes or contact your administrator.",
      retry: "Try again",
    },
    fr: {
      title: "Impossible de charger Dashy",
      message:
        "Vérifiez votre connexion Internet, puis rechargez la page. Si le problème persiste, réessayez dans quelques minutes ou contactez votre administrateur.",
      retry: "Réessayer",
    },
  };
  const storedLanguage = sessionStorage.getItem("lang");
  const language =
    storedLanguage === "ar" || storedLanguage === "en" ? storedLanguage : "fr";

  document.documentElement.lang = language;
  document.documentElement.dir = language === "ar" ? "rtl" : "ltr";
  preboot.classList.add("app-preboot--error");
  preboot.setAttribute("role", "alert");
  preboot.setAttribute("aria-live", "assertive");

  const ring = preboot.querySelector<HTMLElement>(".dashy-loader__ring");
  ring?.remove();
  const loader = preboot.querySelector<HTMLElement>(".dashy-loader");
  if (loader) {
    const errorImage = document.createElement("img");
    errorImage.className = "app-preboot__error-image";
    errorImage.src = "assets/images/orserviceimage.png";
    errorImage.alt = "";
    loader.replaceWith(errorImage);
  }

  const sr = preboot.querySelector<HTMLElement>(".app-preboot__sr");
  sr?.remove();

  const title = document.createElement("p");
  title.className = "app-preboot__title";
  title.textContent = copy[language].title;

  const message = document.createElement("p");
  message.className = "app-preboot__message";
  message.textContent = copy[language].message;

  const retryButton = document.createElement("button");
  retryButton.type = "button";
  retryButton.className = "app-preboot__retry";
  retryButton.textContent = copy[language].retry;
  retryButton.addEventListener("click", () => window.location.reload());

  preboot.append(title, message, retryButton);
}
